import { Location } from "history";

type QueryParameters = { [name: string]: number | string | boolean };

export const fromQueryString = <T>(location: Location): Partial<T> => {
  if (location.search === "") {
    return {};
  }

  const parseValue = (value: string): number | string | boolean => {
    if (value === "true") {
      return true;
    }

    if (value === "false") {
      return false;
    }

    if (value.match(/^\d+$/)) {
      return parseInt(value);
    }

    return value;
  };

  return location.search
    .substring(1) // Remove the leading '?' character
    .split("&")
    .map((pair) => pair.split("=").map(decodeURIComponent))
    .reduce((result, pair) => {
      if (pair.length === 0) {
        return result;
      }

      if (pair.length === 1) {
        return {
          ...result,
          [pair[0]]: true,
        };
      }

      return {
        ...result,
        [pair[0]]: parseValue(pair[1]),
      };
    }, {});
};

export const fromQueryStringStrict = <T>(location: Location, initial: T): T => {
  let val = fromQueryString<T>(location);

  return val ? { ...initial, ...val } : initial;
};

export const toQueryString = (params: QueryParameters) =>
  Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== "")
    .map(
      (param) =>
        encodeURIComponent(param) +
        "=" +
        encodeURIComponent(params[param].toString())
    )
    .join("&");

export const uri = (path: string, params: QueryParameters = {}) => {
  const query = toQueryString(params);

  if (query !== "" && path.indexOf("?") === -1) {
    path += "?";
  }

  return path + query;
};
